// extracted by mini-css-extract-plugin
module.exports = {"btn-primary":"EditForm_btn-primary__2sf2Z","button":"EditForm_button__2oK4D","form-input":"EditForm_form-input__Jw_--","input":"EditForm_input__1yCDd"};